<template>
    <div class="panel-content">
        <h2>FIELD-LAB’s nucleaire infrastructuur</h2>
        <p>Als partner van het FIELD-LAB consortium realiseert NRG de benodigde nucleaire infrastructuur, die alles omvat voor de productontwikkeling van een radioactief medicijn. Van het genereren van nucleair materiaal, tot radiologische laboratoria voor preklinisch onderzoek tot kleinschalige productie van GMP radiofarmaceutica voor klinische proeven.</p>
        <img src="/static/img/overlay-assets/image1-2.jpg" />
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
